module.exports = __webpack_public_path__ + "static/media/blocked_countries.58544f42.svg";